class FTNewsletter extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['button', 'form', 'email', 'content', 'success']
  }

  setupListeners () {
    super.setupListeners()

    this.onFormSubmit = this.onFormSubmit.bind(this)

    this.listeners.add(
      this.els.form.element,
      'submit',
      this.onFormSubmit
    )
  }

  /**
   * Validate email format
   *
   * @param {string} email
   * @returns {boolean}
   */
  isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailRegex.test(email)
  }

  /**
   * @param {Event} event
   *
   * @returns {void}
   */
  onFormSubmit (event) {
    event.preventDefault()

    if (!this.els.email.exists) {
      this.log('Newsletter Submit Error: Email input not found')
      return
    }

    const email = this.els.email.element.value.trim()

    if (!email || !this.isValidEmail(email)) {
      this.log('Newsletter Submit Error: Invalid email', { email })
      return
    }

    // Disable button to prevent double submission
    if (this.els.button.element) {
      this.els.button.element.disabled = true
    }

    // Track to dataLayer for analytics
    window.dataLayer = window.dataLayer || []
    dataLayer.push({
      event: 'newsLetterSubmit',
    })

    this.log('Newsletter Submit', {
      event: 'newsLetterSubmit',
      email: email
    })

    // Track with Elevar if available
    if (window.sendToElevar) {
      window.sendToElevar(this.els.form.element)
    }

    // Submit to Klaviyo
    const url = 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe'
    const data = {
      g: 'Tf4hEr',
      email: email,
      $is_subscribed: true,
      $fields: '$source',
      $source: 'Footer Subscribe'
    }

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Cache-Control': 'no-cache'
      },
      body: new URLSearchParams(data)
    })
    .then(response => response.json())
    .then(response => {
      console.log('Klaviyo subscription successful:', response)
      this.showSuccess()
    })
    .catch(error => {
      console.error('Klaviyo subscription error:', error)
      // Re-enable button on error
      if (this.els.button.element) {
        this.els.button.element.disabled = false
      }
    })
  }

  /**
   * Show success message and hide form
   */
  showSuccess() {
    if (this.els.content.exists) {
      this.els.content.element.setAttribute('aria-hidden', 'true')
    }
    if (this.els.success.exists) {
      this.els.success.element.setAttribute('aria-hidden', 'false')
    }
  }
}

if (!customElements.get('footer-newsletter')) {
  customElements.define('footer-newsletter', FTNewsletter)
}
